import { UserStatus } from '../enums/user.status';
import { UserAddress } from './user.address';

export class AgentApplication {
    userId: string;
    fullName: string;
    mobileNumber: string;
    email: string | null;
    isEmailVerified: boolean;
    companyId: number;
    countryCode: string;
    userRoleId: number;
    roleId: number;
    role: string;
    agentStatus: UserStatus;
    agentStatusMessage: string;
    kycLevel: string;
    isAvailable: boolean;
    operationType: string;
    locationDescription: string | null;
    agentDocsVerified: boolean;
    dateReceived: Date;
    address: UserAddress;

    constructor(data: Partial<AgentApplication>) {
        Object.assign(this, data);
    }
}
